import React, { useEffect } from "react";
import Header from "../../components/bloks/header/Header";
import Footer from "../../components/bloks/footer/Footer";
import OuterBanner from "../../components/outer-page-banner/OuterBanner";
import BannerCard from "../../components/banner-card/BannerCard";
import Steper from "../../components/steper/Steper";
import SteperImage from "../../components/steper/SteperImage";
import Distribution from "../../components/distribution/Distribution";
import OmnibizSolutions from "../../components/omnibiz-solutions/OmnibizSolutions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import GroupBrands from "../../assets/images/group-brands.png";
import { Link } from "react-router-dom";
import SignupModal from "../../components/signup-modal/SignUpModal";

function Manufacturers() {
  useEffect(() => {
    document.title = "Logistics";
  }, []);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div>
      <Header logo={"./images/logo.png"} />

      <OuterBanner backgroundImg={"url(images/logistic-bg.png)"} />
      <BannerCard
        backgroundColor={"linear-gradient(to right, #f95b2f, #f44d21)"}
        icon={"./images/chimni.svg"}
        forOmni={"OmniBiz for"}
        heading={"Logistics"}
        describe={
          "Tap into the opportunities OmniBiz makes available with smart technology. Earn much more with your fleet of vehicles"
        }
        button={"Sign up now"}
        videoPlay={"none"}
      />

      <section className="steper_sec">
        <div className="container">
          <div className="steper_row">
            <div className="steper_grid AAA">
              <SteperImage image={"/images/moving-truck.png"} />
            </div>
            <div className="steper_grid BBB">
              <Steper
                title={"MORE BUSINESS"}
                heading={"Make more with your fleet of vehicles "}
                description={
                  "Earn more with the trade activities of over 120,000 retailers in the OmniBiz community. Tap into the opportunities OmniBiz makes available with smart technology."
                }
              />
            </div>
          </div>

          <div className="steper_row">
            <div className="steper_grid BBB">
              <Steper
                title={"ANALYTICS"}
                heading={"Track the numbers that matter to you"}
                description={
                  "Whether you have 1 or 100s of delivery vehicles, OmniBiz gives you total visibility and real time insights on delivery fulfilments. This is a smart way to monitor your business growth."
                }
              />
            </div>
            <div className="steper_grid AAA">
              <SteperImage image={"/images/steperanalytic.png"} />
            </div>
          </div>
        </div>
      </section>

      <section
        className="joinOver_holder"
        style={{ height: "300px", marginBottom: "270px" }}
      >
        <div className="conteiner">
          <div className="joinOver_card">
            <h3 className="joinOver_h3js">Join Over</h3>
            <span className="joinOver_hightlight">300 Brands</span>
            <h3 className="joinOver_h3js">That trust and work with us.</h3>
            <div className="grp_brands">
              <img src={GroupBrands} alt="" />
            </div>
            <div className="joinOver_actions">
              <a href="#signup" className="signup">
                Sign up now <FontAwesomeIcon icon={faArrowRight} />
              </a>
              <Link to="/contact-us" className="contact">
                Contact us <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Distribution />

      <section className="over_auto solutions_row">
        <div className="solutions_item3colom">
          <OmnibizSolutions
            image={"images/manufactur.png"}
            backgroundColor={"rgb(231 38 53 / 75%)"}
            solutionsfor={"OmniBiz for"}
            title={"Manufacturers"}
            seebtn={"/manufacturers"}
          />
        </div>
        <div className="solutions_item3colom">
          <OmnibizSolutions
            image={"images/distributors-bg.png"}
            solutionsfor={"OmniBiz for"}
            backgroundColor={"rgb(1 16 80 / 80%)"}
            title={"Distributors"}
            seebtn={"/distributors"}
          />
        </div>

        <div className="solutions_item3colom">
          <OmnibizSolutions
            image={"images/retailers-solutions.png"}
            backgroundColor={"rgb(18 124 66 / 80%)"}
            solutionsfor={"OmniBiz for"}
            title={"Retailers"}
            seebtn={"/retailers"}
          />
        </div>
      </section>

      <Footer />
      <SignupModal />
    </div>
  );
}

export default Manufacturers;
